import axios from 'axios'

axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = 'X-CSRFToken'

let ROOT_API = 'http://localhost:5000/api/v1'
if (process.env.NODE_ENV !== 'development') {
  ROOT_API = '/api/v1'
}

export default {
  get (api, auth) {
    return axios.get(ROOT_API + api, {auth: auth})
      .then(res => {
        return res
      })
      .catch(res => {
        return Promise.reject(res)
      })
  },
  post (api, data, auth) {
    return axios.post(ROOT_API + api, data, {auth: auth})
      .then(res => {
        return res
      })
      .catch(res => {
        return Promise.reject(res)
      })
  },
  put (api, data, auth) {
    return axios.put(ROOT_API + api, data, {auth: auth})
      .then(res => {
        return res
      })
      .catch(res => {
        return Promise.reject(res)
      })
  },
  delete (api, params, auth) {
    return axios.delete(ROOT_API + api, {params: params, auth: auth})
      .then(res => {
        return res
      })
      .catch(res => {
        return Promise.reject(res)
      })
  }
}



// WEBPACK FOOTER //
// ./src/api.js